// extracted by mini-css-extract-plugin
export default {"MessagesMobile":"MessagesMobile_MessagesMobile__WPlNC","storyWrapper":"MessagesMobile_storyWrapper__OSY8N","footerWrapper":"MessagesMobile_footerWrapper__qo7bz"};